import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HTTP_INTERCEPTORS, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService } from '../services/alert/alert.service';


@Injectable({
	providedIn: 'root'
})

export class RequestInterceptorService implements HttpInterceptor {

	constructor(private alert: AlertService) { }

	private requests: HttpRequest<any>[] = [];

	removeRequest(req: HttpRequest<any>) {
		const i = this.requests.indexOf(req);
		if (i >= 0) {
			this.requests.splice(i, 1);
		}
		if (this.requests.length > 0) {
			document.getElementById('loader').style.display = 'block'
		} else {
			document.getElementById('loader').style.display = 'none'
		}
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req && req.url.indexOf('config') == -1 && req.url.indexOf('fedsso') == -1 && req.url.indexOf('omnitracsone') != -1) {
			
			let httpHeaders = new HttpHeaders();
			httpHeaders = httpHeaders.set('Cache-Control', 'no-cache');
			httpHeaders = httpHeaders.append('withCredentials', 'true');
			if (req.method.toUpperCase() == 'POST' || req.method.toUpperCase() == 'PUT') {
				httpHeaders = httpHeaders.append('Content-Type', 'application/json');
				httpHeaders = httpHeaders.append('Accept', 'application/json');
			}
			req = req.clone({
				headers: httpHeaders
			});
			this.requests.push(req);
			//start the loader
			document.getElementById('loader').style.display = 'block';
			return Observable.create(observer => {
				const subscription = next.handle(req)
					.subscribe(
						event => {
							if (event instanceof HttpResponse) {
								this.removeRequest(req);
								observer.next(event);
							}
						},
						error => {
							let errorText = "An unexpected error has occurred.";
							switch (error.status) {
								case 401:
									localStorage.clear();
									window.location.reload();
									break;
								case 403:
									break;
								case 500:
									this.alert.showErrorMessage('Error', errorText);
									break;
								default:
									this.alert.showErrorMessage('Error', errorText);
									break;
							}
							this.removeRequest(req);
							observer.error(error);
						},
						() => {
							this.removeRequest(req);
							observer.complete();
						});
				// remove request from queue when cancelled
				return () => {
					this.removeRequest(req);
					subscription.unsubscribe();
				};
			});
		}
		return next.handle(req);
	}
}

export const RequestInterceptor = {
	provide: HTTP_INTERCEPTORS,
	useClass: RequestInterceptorService,
	multi: true
};